<template>
    <div>
        <Accordion>
            <AccordionItem
                v-if="isAvailable(WithdrawalType.instant)"
                :isDisabled="!isShopEligible"
            >
                <div slot="title" class="accordion__title">
                    {{ $t('instant withdrawal') | capitalize }}
                </div>
                <div slot="content">
                    <InstantWithdrawal
                        v-if="isShopEligible"
                        :shops="sortedShops"
                    />
                </div>
            </AccordionItem>
            <AccordionItem
                v-if="isAvailable(WithdrawalType.shop)"
                :isDisabled="!isShopEligible"
            >
                <div slot="title" class="accordion__title">
                    {{ $t('agency withdrawal') | capitalize }}
                </div>
                <div slot="content">
                    <AgencyWithdrawal
                        v-if="isShopEligible"
                        :shops="sortedShops"
                    />
                </div>
            </AccordionItem>
            <AccordionItem
                v-if="isAvailable(WithdrawalType.bankTransfer)"
                :isDisabled="!isBankTransferEligible"
            >
                <div slot="title" class="accordion__title">
                    {{ $t('bank transfer') | capitalize }}
                    <span class="tag">{{ $t('new') | upperCase }}</span>
                </div>
                <div slot="content">
                    <BankTransfer
                        v-if="isBankTransferEligible"
                        :isTaxable="config.countrySpecific.user.withdrawal.isTaxable"
                    />
                </div>
            </AccordionItem>
            <AccordionItem
                v-if="isAvailable(WithdrawalType.online)"
                :isDisabled=" !isOnlineEligible"
            >
                <div slot="title" class="accordion__title">
                    {{ $t('online withdrawal') | capitalize }}
                </div>
                <div slot="content">
                    <OnlineWithdrawal
                        :isTaxable="config.countrySpecific.user.withdrawal.isTaxable"
                    />
                </div>
            </AccordionItem>
            <AccordionItem
                v-if="isAvailable(WithdrawalType.paySafeCard)"
                :isDisabled="!isOnlineEligible"
            >
                <div slot="title" class="accordion__title">
                    {{ $t('paySafe card') | capitalize }}
                    <span class="tag">{{ $t('new') | upperCase }}</span>
                </div>
                <div slot="content">
                    <PscWithdrawal />
                </div>
            </AccordionItem>
        </Accordion>
    </div>
</template>

<script>
    import {
        InstantWithdrawal,
        AgencyWithdrawal,
        BankTransfer,
        OnlineWithdrawal,
        PscWithdrawal,
    } from '@modules/userProfile/withdrawal/AccordionItems';
    import config from '@config';
    import { WithdrawalType } from '@core/models/user/enums';

    export default {
        name: 'WithdrawalList',
        props: {
            isOnlineEligible: {
                type: Boolean,
                required: true,
            },
            isBankTransferEligible: {
                type: Boolean,
                required: true,
            },
            isShopEligible: {
                type: Boolean,
                required: true,
            },
            sortedShops: {
                type: Array,
                required: true,
            },
        },
        created() {
            this.config = config;
            this.WithdrawalType = WithdrawalType;
        },
        methods: {
            isAvailable(type) {
                return config.countrySpecific.user.withdrawal.availableTypes[type];
            }
        },
        components: {
            InstantWithdrawal,
            AgencyWithdrawal,
            OnlineWithdrawal,
            PscWithdrawal,
            BankTransfer,
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/modules/userProfile/withdrawal/components/WithdrawalList.vue